import React, { useMemo, useState } from 'react';
import DefaultTextField from 'components/Utils/DefaultTextField';
import { UncontrolledCollapse } from 'components/Utils/Collapse';
import AddressFields from 'components/Patient/EditAddress/AddressFields';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PerformanceUtils from 'services/PerformanceUtils';
import MenuItem from '@material-ui/core/MenuItem';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppSelector } from 'careand-redux/store';

const INPUT_STYLE = { display: 'inline-block', marginRight: '15px', width: '200px' };

const CorporationDetails = ({ corporation }) => {
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState(false);
  const [value, setValue] = useState({ ...corporation });

  const noChanges = useMemo(
    () => PerformanceUtils.isEqual(corporation, value),
    [corporation, value],
  );

  const plans = useAppSelector((state) => state.payments.clinic_payment_plans);

  function onChange(event) {
    setValue({ ...value, [event.target.name]: event.target.value });
  }

  function onChangeAddress(event, addressValue) {
    let name = event.target.name;
    let address = value.address || {};
    setValue({ ...value, address: { ...address, [name]: addressValue } });
  }

  async function saveChanges() {
    setSaving(true);
    await dispatch(api.Corporations.updateCorporation({ corporation: value }), {
      errorTitle: 'Corporation',
    });
    setSaving(false);
  }

  return (
    <div className="corporation-details box padded-box">
      <span className="large-title">Corporation Details</span>
      <div className="row">
        <DefaultTextField
          name="name"
          label="Name"
          value={value.name}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultTextField
          name="vat"
          label="VAT"
          value={value.vat}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultTextField
          name="phone"
          label="Phone"
          value={value.phone}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultTextField
          name="fax"
          label="Fax"
          value={value.fax}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultTextField
          name="email"
          label="Email"
          value={value.email}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultTextField
          name="contact_name"
          label="Contact Name"
          value={value.contact_name}
          onChange={onChange}
          disabled={saving}
          style={INPUT_STYLE}
        />
        <DefaultSelectField
          label="Payment Plan"
          name="plan"
          style={{ ...INPUT_STYLE, width: '250px' }}
          value={value.plan_id}
          onChange={(event) => setValue({ ...value, plan_id: event.target.value })}
          disabled={saving}
          inputElements={plans.map((plan) => (
            <MenuItem value={plan.id} key={'select-plan-' + plan.id}>
              {`${plan.payment_plan.name} ${plan.payment_plan.interval}`}
            </MenuItem>
          ))}
        />
      </div>
      <UncontrolledCollapse title="Address" initialValue={true}>
        <div style={{ width: '400px' }}>
          <AddressFields
            address={value.address || {}}
            onChange={saving ? undefined : onChangeAddress}
          />
        </div>
      </UncontrolledCollapse>
      <div className="row" style={{ marginTop: '20px' }}>
        <DefaultButton
          name="Save Changes"
          onClick={saveChanges}
          disabled={noChanges}
          loading={saving}
          style={INPUT_STYLE}
        />
      </div>
    </div>
  );
};

export default CorporationDetails;
